import { ReactElement } from 'react';
import { Form, Input } from 'antd';
import { PHONE_PATTERN } from '../../../../../shared/phonePattern';

const Fields = (): ReactElement => (
  <>
    <Form.Item
      label='氏名'
      name='name'
      rules={[
        { required: true, message: '氏名を入力してください' },
        { whitespace: true, message: '氏名を入力してください' },
        { max: 100, message: '氏名は100文字以内で入力してください' },
      ]}
    >
      <Input placeholder='山田太郎' />
    </Form.Item>

    <Form.Item
      label='電話番号'
      name='phone'
      rules={[
        { required: true, message: '電話番号を入力してください' },
        { pattern: PHONE_PATTERN, message: '電話番号は10-11桁の数字で入力してください' },
      ]}
    >
      <Input placeholder='0312345678' />
    </Form.Item>
  </>
);

export default Fields;
